import Main from "../components/examination-result-handling/Main";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/**
 * 審査結果取扱登録.
 */
const ExaminationResultHandling = () => {
  useAuthenticationHook(PERMISSIONS.EXAMINE);
  return <Main />;
};

export default ExaminationResultHandling;
